<div class="snackbar-content">
  {{ data }}
</div>
